import { Component, OnInit } from '@angular/core';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';
import { FormControl } from '@angular/forms';
import { SharedService } from 'app/modules/common/services/shared-service';
import { FilterService } from 'app/modules/selection-generic/services/filter.service';

@Component({
    selector: 'app-consentimiento-filter',
    templateUrl: './consentimiento-filter.component.html',
    styleUrls: ['./consentimiento-filter.component.scss'],
    standalone: false
})
export class ConsentimientoFilterComponent implements OnInit {

  consentimientosOptions = [
    { text: 'Sin Consentimiento', value: '1' },
    { text: 'Con Consentimiento', value: '2' },
    { text: 'Consentimiento entregado', value: '3' },
    { text: 'Consentimiento escrito', value: '4' },
    { text: 'Consentimiento grabado', value: '5' }
  ];

  constructor(public selectionService: SelectionGenericService, private sharedService: SharedService,
              public filterService: FilterService) { }

  ngOnInit(): void {
    // IF USED AS AN ADDITIONAL FILTER
    if (this.sharedService.selectedSelectionTabId === 2) {
      const consentimento = this.selectionService.leaveSelectionModal.Consentimiento === '' ? null : this.selectionService.leaveSelectionModal.Consentimiento.split(',');
      this.filterService.Consentimientos.setValue(consentimento);
    }
  }

  setConsentimento(): void {
    const consentimentosArray = this.filterService.Consentimientos.value;
    let consentimentos = '';
    consentimentosArray.forEach(consentimento => {
      consentimentos += consentimento + ',';
    });

    if (this.sharedService.selectedSelectionTabId === 1) {
      this.selectionService.employeeSelectionModal.Consentimiento = consentimentos.replace(/,\s*$/, '');
    } else {
      this.selectionService.leaveSelectionModal.Consentimiento = consentimentos.replace(/,\s*$/, '');
    }
           
  }

}
